


























import { Component, Prop } from 'vue-property-decorator';
import Form from '@/layouts/Form';

import InputBase from '@/components/input/Input.vue';

import { PartnerGroupResponse, PartnerGroupRequest } from '@/types/models/partnerGroups';

import PartnerGroupEntityModule from '@/store/partnerGroups/entity';

import { Numeric } from '@/types/common';
import CheckboxBase from "@/components/checkbox/Checkbox.vue";

interface FormValues {
    name: string,
    sort: Numeric,
    isActive: boolean,
}

@Component({
    components: {
        CheckboxBase,
        InputBase,
    },
})
export default class partnerGroupsForm extends Form {
    @Prop() formValues?: PartnerGroupResponse; // initial values
    @Prop({ type: Object, default: () => ({}) }) errors!: Record<string, string>;

    values: FormValues = {
        name: '',
        sort: 1,
        isActive: true,
    };

    validationErrors: Partial<Record<keyof FormValues, string>> = {}

    get allErrors() {
        return {
            ...this.errors,
            ...this.validationErrors,
        }
    }

    get model() {
        return PartnerGroupEntityModule.model;
    }

    returnBefore() {
        this.$router.push({ name: 'partnerGroups' });
    }

    initFormValues() {
        if (!this.formValues) {
            return;
        }

        const {
            name = '',
            sort = 1,
            isActive = true,
        } = this.formValues;

        this.values = {
            name,
            sort,
            isActive,
        }
    }

    async createNew() {
        return this.update();
    }

    async update() {
        const data = this.prepareData();

        this.$emit('submit', data);
    }

    prepareData() {
        const {
            name,
            sort,
            isActive,
        } = this.values;

        const request: PartnerGroupRequest = {
            name,
            sort,
            isActive,
        };

        return request;
    }

    mounted() {
        this.initFormValues();
    }
}
